// Video Meetings tab — generate/share a video meeting link with the lead.
// Lightweight: creates a room link the agent can copy or text over.

import React, { useState } from 'react';
import { Video, Copy, Check } from 'lucide-react';
import toast from 'react-hot-toast';

export default function VideoTab({ lead }) {
  const [copied, setCopied] = useState(false);
  const room = `${window.location.origin}/meet/${lead?._id || 'room'}`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(room);
      setCopied(true);
      toast.success('Meeting link copied');
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error('Copy failed');
    }
  }

  return (
    <div className="space-y-3 p-1">
      <div className="rounded-lg bg-civix-panel border border-civix-border p-4 text-center">
        <Video className="w-8 h-8 text-civix-purpleSoft mx-auto mb-2" />
        <p className="text-xs text-white/70 mb-3">Share a secure video meeting link with this lead.</p>
        <div className="flex items-center gap-2">
          <input
            readOnly
            value={room}
            className="flex-1 rounded-lg bg-civix-bg border border-civix-border px-3 py-2
                       text-[11px] text-white/70 outline-hidden"
          />
          <button onClick={copy} className="btn-primary text-xs px-3 py-2 flex items-center gap-1">
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            Copy
          </button>
        </div>
      </div>
    </div>
  );
}
